'use client';

// eslint-disable-next-line import/no-unresolved
import { useInstantSearch } from 'react-instantsearch-next';

/**
 * Search results wrapper that only renders when there's a search query (v7 version)
 */
const SearchResultsWrapperNext = ({ children }) => {
  const { results } = useInstantSearch();

  if (!results || !results.query) {
    return null;
  }

  return children;
};

export default SearchResultsWrapperNext;
